import { render, staticRenderFns } from "./cardTemplateVip35.vue?vue&type=template&id=f7114894&scoped=true&"
import script from "./cardTemplateVip35.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip35.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip35.vue?vue&type=style&index=0&id=f7114894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7114894",
  null
  
)

export default component.exports